// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:20
import { TrafficFlowArgs_abstract } from './../abstract/SagaBase/TrafficFlowArgs_abstract';
export class TrafficFlowArgs extends TrafficFlowArgs_abstract {}
